import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLineChart1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconLineChart1"><Path d="M4.5 19.5V3H3V21H22V19.5H4.5Z" fill="currentColor"/><Path d="M15 17V4H13.5V17H15Z" fill="currentColor"/><Path d="M10 17V10H8.5V17H10Z" fill="currentColor"/><Path d="M20 17V12H18.5V17H20Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLineChart1;
